// extracted by mini-css-extract-plugin
export default {"action":"UserConsent_action__e2mMa","actionColumn":"UserConsent_actionColumn__9ZVlm","actionBar":"UserConsent_actionBar__Fhaov","alert":"UserConsent_alert__GDWAU"};